import React, { useState } from "react";
import { differenceInDays } from "date-fns";
import { useContrato } from "../../../../../../context/ContratoContext";
import { BiMinusCircle, BiPlusCircle } from "react-icons/bi";
import { Produto } from "../produto";



export const ContratoData = () => {
  const { contratosData } = useContrato();
  const [show, setShow] = useState(false);


  async function checkedContrato(
    contrato: string,
    isCheck?: boolean
  ) {
    if (isCheck && show) {
      setShow(true);
      return;
    }

    setShow(!show);
  }

  function formatDate(date: string) {
    const [dia, mes, ano] = date.split("/");
    return `${mes}/${dia}/${ano}`;
  }
  return (
    <>
      {contratosData?.contratos?.length > 0 &&
        contratosData.contratos.map((c) => (
          <div key={c.numcontrato} className={`mb-4 rounded-md bg-white `}>
            <div className="flex w-full rounded-md border border-primary pr-2">
              {/* <div
                className={`mr-2 w-2 rounded-l-md ${c.permitedivida ? " bg-green-500" : " bg-red-500"
                  } `}
              ></div> */}
              <div className="w-full py-2">
                <div className="">
                  <div className="my-2 flex items-center justify-between text-sm px-4">
                    <div className="flex items-center ">
                      <strong className="text-sm font-medium text-gray-600">
                        Contrato: {c.numcontrato}
                      </strong>
                    </div>
                    {/* checked={} onChange={() => setRenda(!renda)} */}

                    {/* <button
                      className="text-lg font-bold"
                      onClick={() => {
                        if (!show) {
                          setShow(true);
                        }
                        checkedContrato(
                          c.numcontrato
                        );
                        // showParcelasContrato(c.numcontrato);
                      }}
                    >
                      {show ? (
                        <BiMinusCircle size={24} className="fill-primary" />
                      ) : (
                        <BiPlusCircle size={24} className="fill-primary" />
                      )}
                    </button> */}
                  </div>
                </div>

                <div className={`${!show && c?.produtos?.length === 0 && "hidden"} px-4`}>
                  <>

                    {
                      c?.produtos && c?.produtos?.length > 0 && c?.produtos?.map(prod => (
                        <Produto produto={prod} />
                      ))

                    }

                    {/* {dividaData && dividaData.length > 0 && (
                      <TabelaParcelasData
                        prestacoes={dividaData}
                        tipoNeg={tipoNeg}
                      />
                    )} */}

                  </>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};
